module.exports = __webpack_public_path__ + "static/media/success(16).2c13ea50.png";